export default __webpack_public_path__ + "static/media/paso24.953deaa6.png";